import { render, staticRenderFns } from "./item-warp.vue?vue&type=template&id=445c019d&scoped=true&"
import script from "./item-warp.vue?vue&type=script&lang=js&"
export * from "./item-warp.vue?vue&type=script&lang=js&"
import style0 from "./item-warp.vue?vue&type=style&index=0&id=445c019d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445c019d",
  null
  
)

export default component.exports